import React from "react";
import BaseChart from "./BaseChart";
import { LensTheme, TimeScope } from "generated/graphql";
import { SeriesComboOptions } from "utilities/chart";

export const ComboChart: React.FC<{
  series?: SeriesComboOptions[];
  colors: Array<string>;
  title?: string;
  timeScope?: TimeScope;
  theme: LensTheme;
  height?: number;
  yAxis?: string;
}> = ({ series, colors, title, timeScope, theme, height, yAxis }) => {
  return (
    <BaseChart
      options={{
        chart: {
          height
        },
        xAxis: {
          tickmarkPlacement: "on",
          crosshair: {
            width: 1
          },
          type: "datetime"
        },
        yAxis: {
          allowDecimals: false,
          title: {
            text: yAxis
          }
        },
        tooltip: {
          dateTimeLabelFormats: {
            hour:
              timeScope === TimeScope.Day ? "%A, %b %e, %H:%M" : "%A, %b %e, %Y" // Only display hourly indicator if data is plotted on an hourly interval
          },
          shared: true
        },
        title: {
          text: title
        },
        series: series
      }}
      colors={colors}
      plotOptions={{
        series: {
          marker: {
            enabled: false
          }
        },
        area: {
          stacking: "normal",
          lineWidth: 1
        }
      }}
    />
  );
};
